import script from "./TopHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TopHeader.vue?vue&type=script&setup=true&lang=js"

import "./TopHeader.vue?vue&type=style&index=0&id=050464fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-050464fc"]])

export default __exports__